import { useEffect } from "react";
import { imgUrl } from "./api";
import { useSite } from "./site";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
};

export const personLd = (s) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  name: s.name,
  jobTitle: s.title,
  url: window.location.origin + "/",
  email: `mailto:${s.contact_email}`,
  sameAs: s.linkedin_url ? [s.linkedin_url] : [],
  description: s.seo_description || s.positioning,
});

export function useSeo({ title, description, image, jsonLd } = {}) {
  const { settings } = useSite();
  const ld = JSON.stringify(jsonLd || null);
  useEffect(() => {
    if (!settings) return;
    const t = title || settings.seo_title || `${settings.name} — ${settings.title}`;
    const d = description || settings.seo_description || settings.positioning;
    const img = imgUrl(image || settings.seo_image || settings.hero_image);
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    let s = document.getElementById("ld-json");
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "ld-json";
      document.head.appendChild(s);
    }
    s.textContent = jsonLd ? ld : JSON.stringify(personLd(settings));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings, title, description, image, ld]);
}
